import { c as _c } from "react/compiler-runtime";
import { GetFaqCategoryQuery } from '@/api/sanity/generated';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { NonNullableField, RequiredBy } from '@/utils/types';
import ChevronRightIcon from '@/assets/icons/heroIcons/Chevron-right.svg';
import Image from 'next/image';
export type Category = RequiredBy<NonNullableField<NonNullable<NonNullable<NonNullable<GetFaqCategoryQuery>['allFaqCategory']>[number]>, 'name' | '_id' | 'slug'>, 'name' | '_id' | 'slug'>;
export function NextCategory(category) {
  const $ = _c(14);
  const t0 = `faqNextCategory${category._id}`;
  const t1 = `faqNextCategory${category._id}`;
  let t2;
  if ($[0] !== category.slug.current) {
    t2 = LINKS().faqCategory(category.slug.current || "");
    $[0] = category.slug.current;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== category.icon || $[3] !== category.name) {
    t3 = category.icon && category.icon.asset?.url && <div><Image width={28} height={28} src={category.icon.asset.url} alt={category.name} /></div>;
    $[2] = category.icon;
    $[3] = category.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== category.name) {
    t4 = <span className="text-sm font-semibold text-gray-900 md:text-base">{category.name}</span>;
    $[5] = category.name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronRightIcon className="ml-auto" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t6 = <Link analyticsParam={t0} testId={t1} to={t2} className="flex items-center gap-2 rounded-lg p-3 no-underline transition-colors hover:bg-blue-100">{t3}{t4}{t5}</Link>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}